export default "__VITE_ASSET__1d7e8d18__"